import { makeAdSupportedGamePolicy } from './game-ads'

/**
 * Hivehold — 벌집 하나를 5분 지키는 단일 기지 인크리멘털 디펜스. 무료 + AdMob 광고 + 광고 제거 인앱결제.
 *
 * 처음부터 광고 골격으로 세웠다 — 수집 0 오프라인 골격(game-offline.ts)을 잠깐이라도
 * 고르면 광고를 붙이는 날 한 문서 안에서 앞뒤가 어긋난다 (privacy-policy.md §새 서비스).
 */
export const HIVEHOLD_POLICY = makeAdSupportedGamePolicy({
  slug: 'hivehold',
  title: 'Hivehold Privacy Policy',
  name: 'Hivehold',
  storedOnDevice:
    'Your coins, which upgrade tiers and passives you have bought, which evolutions you chose, your run records (pests defeated, longest run, total time played, total runs, coins collected), your Daily Siege best for the day, whether you bought the ad removal, and your sound, music and language settings are the only things the app keeps.',
  removeAdsProductId: 'com.cottonray.hivehold.remove_ads',
  effectiveDate: 'September 6, 2026',
  history: [
    'September 6, 2026 — established (structured on Article 30 of the Personal Information Protection Act, including notice of transfers abroad), covering advertising through Google AdMob (a banner in a reserved strip along the bottom while you play and one interstitial when a run ends) and the one-off in-app purchase that removes them. The game requests network access for those two things only',
  ],
})
